import React from 'react';

const IcKakaoSolid = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99998 2C4.46527 2 1.59998 4.31154 1.59998 7.16308C1.59998 9.01921 2.81413 10.6456 4.63602 11.5558C4.50207 12.066 4.15129 13.4034 4.081 13.6897C3.99446 14.0449 4.20865 14.0402 4.3489 13.9444C4.45897 13.8697 6.10282 12.7295 6.81201 12.2372C7.19695 12.2954 7.59382 12.3262 7.99998 12.3262C11.5347 12.3262 14.4 10.0143 14.4 7.16308C14.4 4.31188 11.5347 2 7.99998 2Z"
        fill="#121212"
      />
      <path
        d="M7.99998 2C4.46527 2 1.59998 4.31154 1.59998 7.16308C1.59998 9.01921 2.81413 10.6456 4.63602 11.5558C4.50207 12.066 4.15129 13.4034 4.081 13.6897C3.99446 14.0449 4.20865 14.0402 4.3489 13.9444C4.45897 13.8697 6.10282 12.7295 6.81201 12.2372C7.19695 12.2954 7.59382 12.3262 7.99998 12.3262C11.5347 12.3262 14.4 10.0143 14.4 7.16308C14.4 4.31188 11.5347 2 7.99998 2Z"
        fill="#121212"
      />
    </svg>
  );
};

export default IcKakaoSolid;
